import { useMemo } from "react";
import { useZooplaSearch } from "react-migration/domains/comparables/hooks/useComparableSearch";
import {
  ZooplaPricePerAreaModes,
  ZooplaPricePerUnitModes,
} from "react-migration/domains/comparables/typings/PriceModes";
import { currentValueAverage, lastValueAverage } from "react-migration/domains/comparables/util/ZooplaPrices";
import { LastValueTypeGQL, ZooplaComparableDTO } from "react-migration/lib/typings/Zoopla";
import { getMeasurementSystemPreference } from "src/js/stores/user/actions/getSetting";
import {
  IComparableSearchArgsGQL,
  IComparablesTransaction,
  ISortQuery,
} from "react-migration/lib/typings/comparables/Comparables";

const empty: ZooplaComparableDTO[] = [];

export function useHometrackValue(
  // I don't really want to stick this on the underlying object as this filter
  // really is just for this hometrack part..
  searchCriteria: IComparableSearchArgsGQL & {
    saleValueType?: LastValueTypeGQL;
    rentalValueType?: LastValueTypeGQL;
    propertyType?: string;
  },
  sortCriteria: ISortQuery<IComparablesTransaction>,
  mode: "VAL_LAST" | "VAL_ESTIMATE" | "RENT_ASKING" | "RENT_ESTIMATE"
) {
  const unitPreference = getMeasurementSystemPreference();

  const { data, loading } = useZooplaSearch({
    search: searchCriteria,
    sort: sortCriteria,
    priceMode: ZooplaPricePerAreaModes[mode],
  });

  const transactions = useMemo(
    () => data?.zooplaComparableSearch?.edges.map((edge: any) => edge.node) ?? empty,
    [data?.zooplaComparableSearch?.edges]
  );

  let value = 0;
  let valueArea = 0;

  if (mode === "VAL_LAST" || mode === "RENT_ESTIMATE") {
    value = lastValueAverage(transactions, ZooplaPricePerUnitModes[mode], unitPreference);
    valueArea = lastValueAverage(transactions, ZooplaPricePerAreaModes[mode], unitPreference);
  }
  if (mode === "VAL_ESTIMATE" || mode === "RENT_ASKING") {
    value = currentValueAverage(transactions, ZooplaPricePerUnitModes[mode], unitPreference);
    valueArea = currentValueAverage(transactions, ZooplaPricePerAreaModes[mode], unitPreference);
  }

  return useMemo(
    () => ({
      value,
      valueArea,
      loading,
    }),
    [value, valueArea, loading]
  );
}
